export default __webpack_public_path__ + "static/media/Throwing Knife Icon.a9e5ce49.svg";